(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wtc-dispatch-clock"] && !Shopify.designMode) return;
  try {
    /**
   * Counts down to the next dispatch run on a fixed cycle.
   * The live figure is revealed only once JS confirms it, so a no-JS render
   * never shows a frozen 00:00:00.
   */
  class WtcDispatchClock extends HTMLElement {
    #timer = null;
    #frame = false;

    connectedCallback() {
      this.live = this.querySelector('[data-wdc-live]');
      this.time = this.querySelector('[data-wdc-time]');
      if (!this.live || !this.time) return;

      this.cycleMs = (Number(this.dataset.cycleHours) || 48) * 3600000;
      const anchor = new Date();
      anchor.setHours(Number(this.dataset.anchorHour) || 9, 0, 0, 0);
      this.anchor = anchor.getTime();

      this.live.hidden = false;
      this.#render();
      this.#timer = setInterval(() => this.#schedule(), 1000);
    }

    disconnectedCallback() {
      if (this.#timer) clearInterval(this.#timer);
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = true;
      requestAnimationFrame(() => {
        this.#frame = false;
        this.#render();
      });
    }

    #render() {
      const now = Date.now();
      const since = now - this.anchor;
      const elapsed = ((since % this.cycleMs) + this.cycleMs) % this.cycleMs;
      const remaining = Math.max(0, this.cycleMs - elapsed);

      const total = Math.floor(remaining / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      const hours = Math.floor(total / 3600);
      this.time.textContent = `${pad(hours)}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
    }
  }

  if (!customElements.get('wtc-dispatch-clock')) {
    customElements.define('wtc-dispatch-clock', WtcDispatchClock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wtc-featured-testimonial"] && !Shopify.designMode) return;
  try {
    const WTC_FT_ARROW = {
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>',
  };

  class WtcFeaturedTestimonial extends HTMLElement {
    #index = 0;
    #slides = [];

    connectedCallback() {
      this.track = this.querySelector('[data-wtc-ft-track]');
      if (!this.track) return;

      this.#slides = Array.from(this.track.querySelectorAll('.wtc-ft__slide'));
      if (this.#slides.length === 0) return;

      const total = this.#slides.length;

      for (const [i, slide] of this.#slides.entries()) {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `Testimonial ${i + 1} of ${total}`);
      }

      // A single testimonial needs no controls.
      if (total < 2) {
        this.classList.add('wtc-ft--ready');
        return;
      }

      this.setAttribute('role', 'region');
      this.setAttribute('aria-roledescription', 'carousel');
      this.setAttribute('aria-label', 'Customer testimonials');

      this.#buildNav(total);
      this.classList.add('wtc-ft--ready');
      this.#go(0);

      this.addEventListener('keydown', this.#handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.#handleKeydown);
    }

    #buildNav(total) {
      const nav = document.createElement('div');
      nav.className = 'wtc-ft__nav';

      this.dots = document.createElement('div');
      this.dots.className = 'wtc-ft__dots';
      this.dots.setAttribute('role', 'tablist');
      this.dots.setAttribute('aria-label', 'Choose testimonial');

      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wtc-ft__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Show testimonial ${i + 1} of ${total}`);
        dot.addEventListener('click', () => this.#go(i));
        this.dots.appendChild(dot);
      }

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'wtc-ft__arrow';
      prev.setAttribute('aria-label', 'Previous testimonial');
      prev.innerHTML = WTC_FT_ARROW.prev;
      prev.addEventListener('click', () => this.#go(this.#index - 1));

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'wtc-ft__arrow';
      next.setAttribute('aria-label', 'Next testimonial');
      next.innerHTML = WTC_FT_ARROW.next;
      next.addEventListener('click', () => this.#go(this.#index + 1));

      nav.append(this.dots, prev, next);
      this.appendChild(nav);
    }

    #handleKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.#go(this.#index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.#go(this.#index + 1);
      }
    };

    #go(next) {
      const total = this.#slides.length;
      this.#index = (next + total) % total;
      this.track.style.transform = `translateX(-${this.#index * 100}%)`;

      for (const [i, slide] of this.#slides.entries()) {
        slide.toggleAttribute('aria-hidden', i !== this.#index);
      }

      if (!this.dots) return;
      for (const [i, dot] of Array.from(this.dots.children).entries()) {
        dot.setAttribute('aria-current', String(i === this.#index));
      }
    }
  }

  if (!customElements.get('wtc-featured-testimonial')) {
    customElements.define('wtc-featured-testimonial', WtcFeaturedTestimonial);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wtc-room-image-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wtc-gift-video')) {
  customElements.define('wtc-gift-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      button.addEventListener('click', () => {
        if (!video.dataset.loaded) {
          video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
          video.dataset.loaded = 'true';
          video.load();
        }
        button.hidden = true;
        video.hidden = false;
        video.focus();
        video.play().catch(() => {});
      });
      this.closest('.cro-room-switch').addEventListener('change', event => {
        if (event.target.matches('.cro-room-radio') && event.target.value !== '4') video.pause();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wtc-sale-countdown"] && !Shopify.designMode) return;
  try {
    /**
   * Copies a discount code and confirms it in place.
   * Uses the async clipboard API with a selection fallback for older browsers.
   */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wsc-copy]');
    if (!button) return;

    const code = button.dataset.wscCopy;
    const cue = button.querySelector('[data-wsc-cue]');
    const original = cue?.textContent;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'absolute';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }
      if (cue) {
        cue.textContent = button.dataset.copiedLabel || 'Copied';
        button.dataset.copied = 'true';
        setTimeout(() => {
          cue.textContent = original;
          button.removeAttribute('data-copied');
        }, 2000);
      }
    } catch (error) {
      // Clipboard blocked: the code is still on screen to type manually.
      console.warn('Could not copy the code', error);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
